// TODO: (monorepo) move this to @pkgs/shared

const noop = (..._args: any[]): any => null;

export default noop;
